import { IStateProvider } from 'angular-ui-router';

import { SdcStateBuilder } from './sdc-state-builder.service';

AttendanceRouteConfig.$inject = ['$stateProvider'];

const SDC_KEY = 'attendance';

export function AttendanceRouteConfig($stateProvider: IStateProvider) {
  const attendanceGridState = SdcStateBuilder.buildGridState(SDC_KEY);
  const attendanceProfileState = SdcStateBuilder.buildProfileState(SDC_KEY);

  $stateProvider

    .state(`main.school.new-sdc.${SDC_KEY}`, {
      abstract: true,
      url: `/${SDC_KEY}`,
      template: `
      <sdc-root
      current-user="$resolve.currentUser"
      current-state="$resolve.currentState">
      </sdc-root>
      `,
    })

    .state(`main.school.new-sdc.${SDC_KEY}.grid`, attendanceGridState)
    .state(`main.school.new-sdc.${SDC_KEY}.profile`, attendanceProfileState);
}
